/**
 * Note: This structure is copied over from a previous campaign type and may not be accurate to
 * the new CAC. Leaving as-is for now until we get a better sense of what we need the store
 * structure to be like.
 */
import Vue from "vue";
import STATE from "Constants/campaign/civicactioncenter/state";
import WidgetHelper from "JS/helpers/widgetHelper";
import { isEmpty as _isEmpty } from "lodash";

const widgetHelper = new WidgetHelper();

const mod = {
  namespaced: true,
  state: {
    // be kind and alphabetize
    advocateGoalCounts: {},
    [STATE.ADVOCATE_SHORTURL_ID]: null,
    cacFindCandidates: {
      cta: null,
      description: null
    },
    cacFindElectedOfficials: {
      cta: null,
      description: null
    },
    cacVoterInformation: {
      cta: null,
      description: null
    },
    cacActionOrder: [],
    cacFeaturedContent: [],
    cacFooterContactInfoContent: null,
    cacShowFooterContactInfo: null,
    campaignLogo: null,
    campaignLogoAltText: null,
    contentPageBackgroundImage: null,
    contentPageBackgroundImageAltText: null,
    campaignDesignColors: {},
    formFields: [],
    invalidFormFieldsErrorMessage: null,
    [STATE.P2A_SOURCE_ID]: null,
    pageBackground: null,
    previewMode: false,
    previewModeAlert: "",
    socialShare: {
      socialShareEnabled: false,
      shareEn: false,
      shareTwitterAuthEn: false,
      shareFacebookAuthEn: false,
      contentPageShareImage: null,
      shareTwitterBody: "",
      shareFacebookBody: "",
      shareFacebookURL: "",
      shareLabel: "Share with Others",
      facebookShareEnabled: false,
      twitterShareEnabled: false
    },
    shareOptions: [],
    source: "",
    privacyPolicyUrl: null,
    privacyPolicyUrlLabel: null,
    subscribeEmail: true,
    subscribeEmailLabel: "",
    subscribeSms: true,
    subscribeSmsLabel: "",
    subTitle: null,
    templateId: null,
    unknownErrorMessage: null
  },
  mutations: {
    advocateGoalCounts: (state, stats) => {
      state.advocateGoalCounts = stats;
    },
    settings: (state, settings) => {
      Object.keys(settings).forEach(setting => {
        if (typeof state[setting] !== "undefined") {
          state[setting] = settings[setting];
        }
      });
    }
  },
  actions: {
    advocateGoalCounts({ commit }, stats = {}) {
      commit("advocateGoalCounts", stats);
    },
    [STATE.BROADCAST_DIMENSIONS]({ state, getters }) {
      const { templateId } = state;

      if (getters[STATE.IS_WIDGET]) {
        Vue.nextTick(() => {
          widgetHelper.broadcastDimensions(templateId);
        });
      }
    },
    fromSettings({ commit }, settings = {}) {
      commit("settings", settings);
    }
  },
  getters: {
    advocateGoalCounts(state) {
      return state.advocateGoalCounts;
    },
    [STATE.IS_WIDGET](state) {
      return widgetHelper.isWidget(state);
    },
    [STATE.HAS_FEATURED_CONTENT](state) {
      return (state.cacFeaturedContent && (state.cacFeaturedContent.length > 0));
    },
    [STATE.PRIVACY_POLICY_URL](state) {
      if (!_isEmpty(state[STATE.PRIVACY_POLICY_URL])) {
        return state[STATE.PRIVACY_POLICY_URL];
      }

      return "https://phone2action.com/privacy-policy/";
    }
  }
};

export default mod;
